import { Box, Card, CardMedia, Typography, useTheme } from '@mui/material';
import parse from 'html-react-parser';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import StyledPortfolio from './styles';
// Import css files
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import PortfolioImage1 from '../../../assets/images/portfolio/PortfolioImage1.png';
import PortfolioImage2 from '../../../assets/images/portfolio/PortfolioImage2.png';
import PortfolioImage3 from '../../../assets/images/portfolio/PortfolioImage3.png';
import PortfolioImageEn1 from '../../../assets/images/portfolio/PortfolioImageEn1.png';
import PortfolioImageEn2 from '../../../assets/images/portfolio/PortfolioImageEn2.png';
import PortfolioImageEn3 from '../../../assets/images/portfolio/PortfolioImageEn3.png';
import IconPortfolio1 from '../../../components/Icons/IconPortfolio/IconPortfolio1';
import IconPortfolio2 from '../../../components/Icons/IconPortfolio/IconPortfolio2';
import IconPortfolio3 from '../../../components/Icons/IconPortfolio/IconPortfolio3';

;


import { useTranslation } from 'react-i18next';

const PortfolioCarouselMobile = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const label = t('portfolio-content');
  const portfolioItems = [
    {
      title: '',
      description:
        '게임을 도입함으로서 기존 메가카지노 솔루션을 포함하여 다양한<br/> 종류의 게임을 즐기 실 수 있는 대한민국에서 유일한 장점을 가지<br/>고 있습니다.',
      image: localStorage.getItem('i18nextLng') === 'en-US' ? PortfolioImageEn1 : PortfolioImage1,
      icon: <IconPortfolio1 />,
    },
    {
      title: '더 킹 플러스<br/> THE KING PLUS',
      description:
        '2010년대 부터 운영되어온 국내 최대의 사용자들이 이용하고<br/> 있는 메머드급 카지노 사이트로 소액부터 고액까지 다양한 겜<br/> 블러들이 이용하고 있는 메이저 온라인 카지노 사이트 입니다.',
      image: localStorage.getItem('i18nextLng') === 'en-US' ? PortfolioImageEn2 : PortfolioImage2,
      icon: <IconPortfolio2 />,
    },
    {
      title: '스페이스맨 카지노<br/> SPACE MAN CASINO',
      // description:
      //   '스페이스맨카지노 는 우리카지노 계열 메이저 카지노 사이트로 독특한 매<br/> 력과 강점을 갖추고 있습니다. 다양한 게임과 풍부한 혜택을 제공하여 사용<br/> 자들의 만족도를 최고로 끌어올리며, 시간이 지남에 따라 지속적인 향상을<br/> 이루어내고 있습니다.',
      description:
        '스페이스맨카지노 는 우리카지노 계열 메이저 카지노 사이트로 독특한 매 력과 강점을 갖추고 있습니다. 다양한 게임과 풍부한 혜택을 제공하여 사용 자들의 만족도를 최고로 끌어올리며, 시간이 지남에 따라 지속적인 향상을 이루어내고 있습니다.',
      image: localStorage.getItem('i18nextLng') === 'en-US' ? PortfolioImageEn3 : PortfolioImage3,
      icon: <IconPortfolio3 />,
    },
    // {
    //   title: '',
    //   description:
    //     '게임을 도입함으로서 기존 메가카지노 솔루션을 포함하여 다양한<br/> 종류의 게임을 즐기 실 수 있는 대한민국에서 유일한 장점을 가지<br/>고 있습니다.',
    //   image: Kansino,
    //   icon: <IconPortfolio1 />,
    // },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* <Wave
        fill="#fff"
        paused={false}
        style={{ display: 'flex', position: 'absolute', zIndex: 999, marginTop: '-46px' }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
      /> */}
      <StyledPortfolio>
        <Box sx={{ maxWidth: '1264px', margin: '0 auto', padding: '20px', position: 'relative' }}>
          <Typography
            variant="h4"
            textAlign="center"
            gutterBottom
            sx={{
              color: '#000000',
              fontSize: '40px',
              fontWeight: 700,
              mb: 10,
              [theme.breakpoints.down('lg')]: {
                mt: 5,
                mb: 5,
              },
            }}
          >
            {t('portfolio-title')}
          </Typography>
          <Box
            sx={{
              display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none', xl: 'none' },
            }}
          >
            <Typography
              sx={{
                fontSize: '18px',
                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                lineHeight: '23.4px',
                color: '#000000',
                textAlign: 'center',
                mb: 5,
                [theme.breakpoints.down('lg')]: {
                  padding: '0px 30px',
                },
              }}
            >
              {parse(label)}
            </Typography>
          </Box>
          <Carousel>
            {portfolioItems.map((item, index) => (
              <Card
                key={index}
                sx={{
                  margin: '0 20px',
                  background: 'var(--color-white-solid, #FFF)',
                  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
                  // borderBottomLeftRadius: '8px',
                  // borderBottomRightRadius: '8px',
                  borderRadius: '20px',
                }}
              >
                <CardMedia
                  component="img"
                  // sx={{
                  //   height: '270px',
                  //   width: '500px',
                  //   [theme.breakpoints.down('lg')]: {
                  //     width: '500px',
                  //     height: '216px',
                  //   },
                  // }}
                  class="cardMedia"
                  image={item.image}
                  alt={item.title}
                />
                {/* <CardContent>
                  <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    // padding={'0 20px 0 48px'}
                  >
                    <Box sx={{ width: '50%' }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: '20px',
                          fontWeight: 700,
                          color: '#6C6964',
                          lineHeight: '24px',
                          [theme.breakpoints.down('lg')]: {
                            fontSize: '14px',
                            lineHeight: '24.96px',
                          },
                        }}
                      >
                        {parse(item.title)}
                      </Typography>
                    </Box>
                    {item.icon}
                  </Box>
                  <Box padding={'0 5px 0 5px'}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        fontSize: '17.462px',
                        fontWeight: 600,
                        lineHeight: '25.6px',
                        color: '#6C6964',
                        mb: 5,
                        [theme.breakpoints.down('lg')]: {
                          fontSize: '14px',
                          lineHeight: '24.96px',
                        },
                      }}
                    >
                      {parse(item.description)}
                    </Typography>
                  </Box>
                </CardContent> */}
              </Card>
            ))}
          </Carousel>
        </Box>
      </StyledPortfolio>
    </>
  );
};

export default PortfolioCarouselMobile;
